export { default } from './PopTipCDS';
